module.exports = __webpack_public_path__ + "img/66d8381d5715d1cdd70eaa7f3268d1beaa8c0a1b.74463517.jpg";